import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/axios.js";

const FirstLoginPassword = () => {
    const location = useLocation();
    const empId = location.state?.empId;
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // for fist login, users has to change password

    const passwordSetting = async (event) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }

        try {
            // after first login, change to new password

            await api.post("/auth/first-login-password", {
                employeeId: empId,
                password: password,
            });

            navigate("/password", { state: { empId } });

        } catch (err) {
            console.error(err);
            let message = "Request failed";
            if (err.response && err.response.data && err.response.data.message) {
                message = err.response.data.message;
            }
            alert(message);
        }
    };

    return (
        <>
            <div className="logo">
                <img src="/images/logo-circle-dark.png" alt="logo" className="circle"/>
                <img src="/images/brevia-brown.png" className="brevia"></img>
            </div>
            <div className="logo-wrapper">
                <div className="login-wrapper">
                    <h2>Log In</h2>
                    <form onSubmit={passwordSetting} className="password_form">
                        <input
                            type="hidden"
                            value={empId}
                            readOnly
                        />
                        <label htmlFor="set-pw">Set your new password</label>
                        <div className="input_wrapper">
                            <input
                                id="set-pw"
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="new-password"
                                required
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </span>
                        </div>

                        <label htmlFor="confirm-pw">
                            Confirm your password
                        </label>
                        <div className="input_wrapper">
                            <input
                                id="confirm-pw"
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Confirm your password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <span
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                            </span>
                            <a href="/forgotPassword" className="forgot-link">Forgot your password?</a>
                        </div>

                        <button type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </>
    )

}

export default FirstLoginPassword;